import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import sortBy from 'lodash/sortBy';
import { NavMenu } from '@uhg-abyss/web/ui/NavMenu';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { NavMenuLink } from 'src/common/NavMenuLink';
import { MediaQuery } from '@uhg-abyss/web/ui/MediaQuery';

const COLUMN_SPACE = { height: '43px' };

const SpacerForAbyssNavMenuSecondColumn = () => {
  return <div style={COLUMN_SPACE} />;
};

export const DropdownContent = ({ dropdownKey }) => {
  const { getHeaderContents } = usePPDLagoon();
  const dropdownContents = getHeaderContents('navMenu', dropdownKey);

  const arrayOfSections = sortBy(
    dropdownContents.filter((content) => {
      return content.type === 'section';
    }),
    'order'
  );

  const filterBySection = (sectionId) => {
    return sortBy(
      dropdownContents.filter((content) => {
        return content.section?.toUpperCase() === sectionId;
      }),
      'order'
    );
  };

  const filterSectionByColumn = (sectionId, columnNumber) => {
    return sortBy(
      dropdownContents.filter((content) => {
        return (
          content.section?.toUpperCase() === sectionId &&
          content.column === (columnNumber + 1).toString()
        );
      }),
      'order'
    );
  };

  return (
    <NavMenu.Columns>
      <For each="section" of={arrayOfSections}>
        <Choose>
          <When condition={section.numberOfColumns}>
            <For each="column" of={range(section.numberOfColumns || 1)}>
              <NavMenu.Column title={column === 0 ? section.name : null}>
                <MediaQuery largerThan={984}>
                  {column !== 0 && <SpacerForAbyssNavMenuSecondColumn />}
                </MediaQuery>

                <For
                  each="content"
                  of={filterSectionByColumn(section.key, column)}
                >
                  <NavMenuLink {...content} />
                </For>
              </NavMenu.Column>
            </For>
          </When>
          <Otherwise>
            <NavMenu.Column title={section.name}>
              <For each="content" of={filterBySection(section.key)}>
                <NavMenuLink {...content} />
              </For>
            </NavMenu.Column>
          </Otherwise>
        </Choose>
      </For>
    </NavMenu.Columns>
  );
};

DropdownContent.propTypes = {
  dropdownKey: PropTypes.string.isRequired,
};
